import React from "react";
import { connect } from "react-redux";
import {
    Input,
    Row,
    Col,
    Label
} from "reactstrap";
import { pageActions } from "../../../../../store/actions/cms/page/page.action";
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import { sourceTypes } from "../../../../../constants/cms/sourceType";
import { deepClone } from "../../../../../helpers/objectHelper";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import { templateHelper } from "../../../../areas/template/helpers/templateHelper";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import EditorSlider from "../../../../components/editor/tools/EditorSlider";
import axios from 'axios';
import { FloatingChecklist } from "../../../../components/editor/tools/FloatingChecklist/FloatingChecklist";

const API_KEY = 'AIzaSyAfkmGGdpqu1LNCDkioaAJLvlZ4ezLOcNE'
class MapSettings extends React.Component {
    state = {
        results: []
    }
    handleSoftUpdate = (element) => {
        const { dispatch, enviroment, page } = this.props;
        if (enviroment === sourceTypes.FORM)
            dispatch(formActions.updateFormElement(element));
        if (enviroment === sourceTypes.PAGE)
            dispatch(pageActions.updatePageElement(element, null, page));
        if (enviroment === sourceTypes.TEMPLATE) {
            const template = deepClone(this.props.template);
            const newTemplate = templateHelper.handleElementUpdates(element, template);
            dispatch(templateActions.softUpdate(newTemplate));
        }
    };
    addressOnChange = (address) => {
        const element = deepClone(this.props.selectedElement);
        element.props.value = address;
        this.setState({ results: [] })
        this.handleSoftUpdate(element);
    }

    handleChange = (color, val, path) => {
        const names = path.split(".");
        const element = deepClone(this.props.selectedElement);
        let value = color ? this.parseColorToRgba(color) : val;
        if (names.length === 2) {
            element[names[0]][names[1]] = value;
        }
        if (names.length === 3) {
            element[names[0]][names[1]][names[2]] = value;
        }
        this.handleSoftUpdate(element);
    }
    getResultFromInput = (address) => {
        if (address.length < 4) return;
        const { props } = this.props.selectedElement;
        axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${address.replace(' ', '+')}&key=${API_KEY}`)
            .then(res => {
                const results = [];
                res.data.results.map(r => {
                    results.push({
                        address: r.formatted_address,
                        isCurrent: (props.value && props.value === r.formatted_address)
                    })
                })
                this.setState({ results })
            })
    }
    render() {
        const { selectedElement } = this.props;
        return (
            <div>
                <ListExpansion footer={false} icon="fa fa-image" defaultExpanded={true} description="MapSettings">
                    <EditorSlider
                        value={parseFloat(selectedElement.data.zoom)}
                        defaultValue={parseFloat(selectedElement.data.zoom)}
                        unitChange={() => null}
                        onChange={this.handleChange}
                        units={[""]}
                        activeUnit={''}
                        steps={1}
                        min={10}
                        max={15}
                        path={'data.zoom'}
                        label="Scale"
                    />
                    <hr />
                    <EditorSlider
                        value={parseFloat(selectedElement.data.style.height)}
                        defaultValue={parseFloat(selectedElement.data.style.height)}
                        unitChange={() => null}
                        onChange={this.handleChange}
                        units={["px"]}
                        activeUnit={'px'}
                        steps={1}
                        min={1}
                        max={1000}
                        path={'data.style.height'}
                        label="Height"
                    />
                    <hr />
                    <Row >
                        <Col className="list-setting-item-title">
                            <Label>
                                <SystemLabel name="Address" />
                            </Label>
                        </Col>
                    </Row>
                    <Row >
                        <Col className="list-setting-item-title">
                            <Input autoComplete="jirango-nofill" placeholder="" defaultValue={selectedElement.props.value} onChange={(e) => this.getResultFromInput(e.target.value)} /* onBlur={(e) => this.handleChange(this.state.value, 'props.value')} */ />
                            {this.state.results.length > 0 ? <FloatingChecklist onCheck={this.addressOnChange} list={this.state.results} /> : null}
                        </Col>

                    </Row>
                    <Row>
                        <Col className="list-setting-item-title">
                            <p
                                className="text-muted"
                                style={{ lineHeight: "initial", marginTop: "5px" }}
                            >
                                <SystemLabel name="AddressSearchInfo" />
                            </p>
                        </Col>
                    </Row>

                </ListExpansion>
            </div >
        );
    }
}
function mapStateToProps(state) {
    const { enviroment } = state.cms;
    let selectedElement = null;
    if (enviroment === sourceTypes.FORM) selectedElement = state.form.selectedElement;
    if (enviroment === sourceTypes.PAGE) selectedElement = state.page.selectedElement;
    if (enviroment === sourceTypes.TEMPLATE) selectedElement = state.template.selectedElement;
    return {
        enviroment: enviroment,
        template: state.template.template,
        form: state.form,
        page: state.page,
        selectedElement: selectedElement,
    };
}
export default connect(mapStateToProps)(MapSettings);
